export interface PaymentAnalyticsDto {
  payments_sum_total: number;
  commission_sum_total: number;

  payment_statistics: PaymentAnalyticsDayDto[];
  total_statistics: StatUnitDto[];
}

export interface PaymentAnalyticsDayDto {
  date: string;
  month_statistics: StatUnitDto[];
  statistics: StatUnitDto[];
}

export interface StatUnitDto {
  date?: string;
  commission: number;
  payment_type: PaymentType;
  sum: number;
}

export interface ReturnStatUnitDto {
  refund_sum: number;
  payment_type: ReturnType;
  quantity: number;
}

export interface PaymentAnalyticsDay {
  date: string;

  totalCommission: number;

  paymentByLinkSum: number;
  paymentByQrSum: number;
  paymentByWebsiteSum: number;
  recurringPaymentSum: number;

  linkPaymentCommission: number;
  qrPaymentCommission: number;
  sitePaymentCommission: number;
  recurringPaymentCommission: number;
}

export interface ReturnAnalyticsDay {
  date: string;

  refundSum: number;
  quantity: number;

  returnsByP2pSum: number;
  returnsByCash: number;
  returnsByTransitAccount: number;
}

export interface RefundsAnalyticsDto {
  qty_total: number;
  sum_total: number;

  statistics: RefoundsAnalyticsDayDto[];
  total_statistics: ReturnStatUnitDto[];
}

export interface RefoundsAnalyticsDayDto {
  date: string;
  quantity: number;
  refund_sum: number;

  month_statistics: StatUnitRefoundDto[];
  statistics: StatUnitRefoundDto[];
}

export interface StatUnitRefoundDto {
  refund_type: ReturnType;
  sum: number;
}

export enum PaymentBarState {
  AllPayments = -1,
  Commision = 0,
  LinkPayment = 1,
  QrPayment = 2,
  RecurringPayment = 3,
  SitePayment = 4,
}

export enum ReturnBarState {
  AllPayments = -1,
  P2p = 0,
  TransitAccount = 1,
  ExternalSystems = 2,
}

export enum DateState {
  Week = 0,
  Month = 1,
  Year = 2,
}

export interface PaymentsPercents {
  linkSum: number;
  qrSum: number;
  recurringSum: number;
  websiteSum: number;
}

export interface ReturnsPercents {
  p2pSum: number;
  transitionSum: number;
  externalSum: number;
}

export type PaymentType =
  | 'PAYMENT_LINK'
  | 'QR_CODE_PAYMENT'
  | 'RECURRENT_PAYMENTS'
  | 'PAYMENT_FROM_SITE';

export type ReturnType = 'RETURNS' | 'P2P_REFUNDS' | 'CASH_REFUNDS';

export interface PaymentSystemInfoDto {
  income: number;
  last_income: number;
  bank_commission: number;
  last_bank_commission: number;
  transactions: number;
  last_transactions: number;
}

export interface PaymentSystemInfoPercents {
  incomePercent: number;
  bankPercent: number;
  transactionsPercent: number;
}

export interface AnalyticsInfoDto {
  new_counter: number;
  in_process_counter: number;
  solved_counter: number;
}

export type SupportDataDto =
  | 'USER_MANAGEMENT'
  | 'VIRTUAL_POS_MANAGEMENT'
  | 'TRANSACTION_MANAGEMENT'
  | 'PAYMENT_LINKS'
  | 'ANALYTICS_REPORTING'
  | 'TERMINAL_MANAGEMENT'
  | 'SAVED_CARDS'
  | 'REFUNDS'
  | 'P2P'
  | 'OTHER';

// SupportTypeStatisticsDto status
//0 = NEW
//1 = IN_PROCESS
//2 = REWIEVED
export interface SupportTypeStatisticsDto {
  status: number;
  quantity: number;
}
export interface RequestsDataDto {
  support_type: SupportDataDto;
  support_type_statistics: SupportTypeStatisticsDto[];
}

export interface PaymentPageUnitDto {
  hits_counter: number;
  month: string;
  successful_transactions_counter: number;
}

export interface PaymentPageDataDto {
  payment_page_statistics: PaymentPageUnitDto[];
  total_hits: number;
  total_successful_transactions: number;
}

export interface SelectMonthUnit {
  fieldName: any;
  value: number;
}
